import { uniqueId } from 'lodash';
import { useMemo } from 'react';

export const useUniqueId = (prefix?: string, id?: string) => {
  return useMemo(() => id? `${prefix}-${id}`: uniqueId(prefix), [prefix, id]);
};
